import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CInputGroup,
	CInputGroupText,
	CFormSelect,
	CButton,
	CImage,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CSpinner,
	CLink,
	CDropdown,CDropdownItem,CDropdownToggle,CDropdownMenu,
	CTooltip,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { isMobile } from "react-device-detect";
import {
	MyDialogview,
	MyDialogform,
	MyPagination,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc,cAngkaTgl,cBulanPendek,cBulanPanjang } from '../helpers/functions'

const pjson 	= require('../../package.json')
const Lapperawat= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uSystemsettingObj			= useSelector(state => state.gSystemsetting);
	const uEfekapp					= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 25) : (uSettingObj.jml_laporan || 100);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uSelisihrangetanggal 		= useSelector(state => state.gSelisihrangetanggal);
	
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction);
	const uHandelView 				= uHeaderActionObj.isHeaderView || false;
	const uHandelReset 				= uHeaderActionObj.isHeaderreset || false;

	//--VIEWS_VARS--/
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const uIsHapusallow					= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") ? true : false;
	const [uIsDataloaded,setDataloaded]	= React.useState(false); 
	const [uCaptionObj,setCaptionObj]	= React.useState({}); 
	const [uFilterObj,setFilterObj]		= React.useState({});
	const [uFirstload,setFirstload]		= React.useState("YA");
	const [uSortedObj,setSortedObj]		= React.useState({});
	//const uFilterObj		  		= useSelector(state => state.gFilterObj) || {};

	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uIDselect,setIDselect]		= React.useState(0);

	const uDatacabangArr				= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const [uDatadefaultArr,setDatadefaultArr]= React.useState([]);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uDataperawatArr,setDataperawatArr]= React.useState([]); 
	const [uDatasumArr,setDatasumObj]	= React.useState({});
	//--END VIEWS_VARS--*/

	//--DLG_FORM--/
	const [uISDlgformshow,setDlgformshow]	= React.useState(false);
	const [uHeaderDlgform,setHeaderDlgform]	= React.useState("");
	const [uFormdataObj,setFormdataObj]		= React.useState({});
	//--END DLG_FORM--/

	//--DLG_VIEW--/
	const [uISDlgviewshow,setDlgviewshow]	= React.useState(false);
	const [uDlgviewObj,setDlgviewObj]		= React.useState({});
	//--END DLG_VIEW--/

	//--DOM_VARS--/
	const uElJmlData					= document.getElementById("idjmldata");
	const [uElBtnsimpan,setElBtnsimpan]	= React.useState(document.getElementById("btnDialogSimpan"));
	const fileType 		= "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension = ".xlsx";
	//--END DOM_VARS--/

	//--SETTING_CETAK--/
	const uHTMLstylelaporan		= useSelector(state => state.gHTMLstyleLaporan);
	const uFrameExport 			= document.getElementById("ifmcontentstoprint");
	//--END SETTING_CETAK--/

	//--HANDEL--/
	const hdlToggleDlgform = () => { setDlgformshow(false) }
	const hdlKlikDlgsimpan = () => {
		//--VALIDASI_FILTER--/
		let vElfocus	= document.getElementById("inpcabangid");
		if(parseInt(uFormdataObj.cabang_id||"0") <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Cabang Harus Dipilih !");
			return
		}

		vElfocus		= document.getElementById("inptglawal");
		const vTglawal 	= uFormdataObj.tgl_awal;
		if(!UFunc.isDateValid(vTglawal)) {
			vElfocus && vElfocus.focus();
			showToast("Tanggal Awal Laporan Tidak Valid !"); return
		}
		const vTglawalDT	= UFunc.toDate(vTglawal);
		if(UFunc.DateIsBeyond(vTglawalDT)) {
			vElfocus && vElfocus.focus();
			showToast("Tanggal Awal Laporan Melewati Tanggal SAAT INI ! "); return
		}

		vElfocus		= document.getElementById("inptglakhir");
		const vTglakhir	= uFormdataObj.tgl_akhir;
		if(!UFunc.isDateValid(vTglawal)) {
			vElfocus && vElfocus.focus();
			showToast("Tanggal Akhir Laporan Tidak Valid !"); return
		}
		const vTglakhirDT	= UFunc.toDate(vTglakhir);
		const vTglnowDT		= new Date();
		const vTglbatasDT	= new Date(vTglnowDT.getFullYear(),vTglnowDT.getMonth()+1,0);

		//alert(vTglbatasDT+"<br/>"+vTglakhirDT);return;
		if(UFunc.SelisihHari(UFunc.DbDate(vTglbatasDT),UFunc.DbDate(vTglakhirDT)) > 0) {
			vElfocus && vElfocus.focus();
			showToast("Tanggal Akhir Laporan Melewati Tanggal BULAN INI ! "); return
		}

		if(UFunc.SelisihHari(UFunc.DbDate(vTglawalDT),UFunc.DbDate(vTglawalDT)) > uSelisihrangetanggal) {
			vElfocus && vElfocus.focus();
			showToast("Maksimal Selisih Range Tanggal adalah "+uSelisihrangetanggal+" hari.."+
				"<br/>Mohon Diperbaiki !"+
				""); return
		}
		//alert(vTanggalDT);return;
		//--END VALIDASI_FILTER--/

		setDataloaded(false);
		apiLoaddata();
	}
	const hdlKlikSort = (_NAMAKOL) => {
		_NAMAKOL		= (_NAMAKOL||"").toUpperCase();
		const vNamenow	= (uSortedObj.nama||"").toUpperCase();
		const vSortnow	= (uSortedObj.jenis||"").toUpperCase();

		const vSortedObj		= uSortedObj;
		vSortedObj.init_aktif 	= "YA";
		if(vNamenow==="" || vNamenow !== _NAMAKOL) {
			vSortedObj.nama 	= _NAMAKOL.toLowerCase();
			vSortedObj.jenis 	= "ASCENDING";
		} else if(vNamenow===_NAMAKOL) {
			if(vSortnow==="ASCENDING")
				vSortedObj.jenis = "DESCENDING";
			else if(vSortnow==="DESCENDING") {
				 vSortedObj.nama 	= "";
				 vSortedObj.jenis 	= "";
			}
		}
		vSortedObj.init_aktif 	= undefined;

		setSortedObj(vSortedObj);
		setEfekview(!uEfekview);
	}
	const hdlKlikCetak = () => {
		if(uDatamainArr.length <= 0) return;

		const vContent 	= contentCetak();
		if(vContent === "") return
		//console.log("(Lapperawat - hdlKlikCetak) vContent = "+vContent)

		var pri 		= uFrameExport.contentWindow;
		pri.document.open();
		pri.document.write(vContent);
		pri.document.close();
		pri.window.focus();
		pri.window.print();
	}
	const hdlKlikExcel = () => {
		if(uDatamainArr.length <= 0) return;

		if(parseInt(uFilterObj.perawat_id||"0") <= 0) 
			{ excelBulanall(); return; }

		if(parseInt(uFilterObj.perawat_id||"0") > 0)
			{ excelBulanperawat(); return; }
	}
	const hdlKlikDetil = (_IDTABEL) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vRowidx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setRowselect(vRowidx);
		const vCaptionupper	= (uDatamainArr[vArridx].tgl_periksa)+" &middot; "+
			(uDatamainArr[vArridx].pasien_caption||"Undf").toUpperCase()+
			"";

		uDlgviewObj.dlg_header	= "Detil Kunjungan: "+vCaptionupper;
		uDlgviewObj.tabelid		= _IDTABEL;
		if((uDatamainArr[vArridx].data_arr || []).length > 0) {
			uDlgviewObj.data_obj	= uDatamainArr[vArridx] || {};
			setDlgviewshow(true);
			return;
		}

		apiLoaddetil();
	}
	//--END HANDEL--/

	//--INIT--/
	const initResettampilan = () => {
		setCaptionObj({}); setDatamainArr([]);// setJmlData(0);
		setFilterObj({}); setSortedObj({});
	}
	const initJmldata = () => {
		uElJmlData 
			&& (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	}
	const excelBulanall = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";

		const vNurseIdx		= UFunc.getObjectIndeks(uDataperawatArr,uFilterObj.perawat_id);
		const vNursecaption	= vNurseIdx >= 0 ? uDataperawatArr[vNurseIdx].nama_perawat : "";

		const vColspan		= 4;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			nama_perawat : "",
			nilai_poin : "",
		};
		vDatasetsArr.push(vTmpObj);

		vRowcount++;
		uDatamainArr.map((vItems,vKeys)=>{
			const {
				nama_perawat,nilai_poin,rate_bintang
			} = vItems;

			vRowcount++;
			vColposwidth = (nama_perawat||"").length > vColposwidth 
				? (nama_perawat||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				nama_perawat: (nama_perawat||"Undf Terapi"),
				nilai_poin: { v:parseFloat(nilai_poin), t:"n", s:{numFmt: "#,##0.#0"} },
				rate_bintang: { v:parseFloat(rate_bintang), t:"n", s:{numFmt: "#,##0.#0"} },
			}
			vDatasetsArr.push(vTmpObj);
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			nama_perawat: "",
			nilai_poin: { v:parseFloat(uDatasumArr.nilai_poin)||0, t:"n", s:{numFmt: "#,##0.#0",font:{bold:true} } },
			rate_bintang: { v:parseFloat(uDatasumArr.rate_bintang)||0, t:"n", s:{numFmt: "#,##0.#0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:45}]
		const wscols	= [
			{wpx:40},
			{wch:vColposwidth},
			{wpx:100},
			{wpx:100},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 3}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPPERAWAT_"+
			(uFilterObj.tgl_awal||"").replace(/-/g,"")+"_"+
			(uFilterObj.tgl_akhir||"").replace(/-/g,"")+
		"";
		const vSheetlabel 	= (uFilterObj.tgl_awal||"").replace(/-/g,"")+"_"+
			(uFilterObj.tgl_akhir||"").replace(/-/g,"");
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode "+UFunc.HariAngka(uFilterObj.tgl_awal)+" s.d. "+
			UFunc.HariAngka(uFilterObj.tgl_akhir)+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Nama Perawat",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Poin",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Rate Rata2",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	const excelBulanperawat = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";

		const vNurseIdx		= UFunc.getObjectIndeks(uDataperawatArr,uFilterObj.perawat_id);
		const vNursecaption	= vNurseIdx >= 0 ? uDataperawatArr[vNurseIdx].nama_perawat : "";

		const vColspan		= 8;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			tgl_periksa : "",
			tgl_lunas : "",
			pasien_caption : "",
			dokter_caption : "",
			catatan : "",
			nilai_poin : "",
			rate_bintang : "",
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;

		uDatamainArr.map((vItems,vKeys)=>{
			const {
				id,dokter_caption,pasien_caption,catatan,
				nilai_poin,tgl_periksa,tgl_lunas,rate_bintang,
			} = vItems;

			vColposwidth = (catatan||"").length > vColposwidth 
				? (catatan||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				tgl_periksa : {v:tgl_periksa,t:"d",s:{alignment:{horizontal:"left"}}},
				tgl_lunas : {v: ((tgl_lunas||"")!=="" ? (tgl_lunas) : "-"),t:(tgl_lunas||"")!=="" ?"d":"s",s:{alignment:{horizontal:"left"}}},
				pasien_caption: (pasien_caption||"Undf Pasien"),
				dokter_caption: (dokter_caption||"Undf Dokter"),
				catatan: (catatan||"-"),
				nilai_poin: { v:parseFloat(nilai_poin), t:"n", s:{numFmt: "#,##0.#0"} },
				rate_bintang: { v:parseFloat(rate_bintang), t:"n", s:{numFmt: "#,##0.#0"} },
			}
			vDatasetsArr.push(vTmpObj);
			vRowcount++;
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH / Rata2",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			tgl_periksa: "",
			tgl_lunas: "",
			pasien_caption: "",
			dokter_caption: "",
			catatan: "",
			nilai_poin: { v:parseFloat(uDatasumArr.nilai_poin)||0, t:"n", s:{numFmt: "#,##0.#0",font:{bold:true} } },
			rate_bintang: { v:parseFloat(uDatasumArr.rate_bintang)||0, t:"n", s:{numFmt: "#,##0.#0",font:{bold:true} } },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:66.75}]
		const wscols	= [
			{wpx:40},
			{wpx:100},
			{wpx:100},
			{wpx:180},
			{wpx:180},
			{wch:vColposwidth},
			{wpx:75},
			{wpx:75},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 3}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPPERAWAT_"+
			(uFilterObj.tgl_awal||"").replace(/-/g,"")+"_"+
			(uFilterObj.tgl_akhir||"").replace(/-/g,"")+
		"";
		const vSheetlabel 	= (uFilterObj.tgl_awal||"").replace(/-/g,"")+"_"+
			(uFilterObj.tgl_akhir||"").replace(/-/g,"")+
			"";
		const ws 			= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode "+UFunc.HariAngka(uFilterObj.tgl_awal)+" s.d. "+
				UFunc.HariAngka(uFilterObj.tgl_akhir)+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
			"\r\n"+vNursecaption+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Tgl Periksa",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Tgl Lunas",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Nama Pasien",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Dokter",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Catatan",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Poin",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Rating",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	//--END INIT--/

	//--CONTENT--/
	//console.log("uDataperawatArr => "+JSON.stringify(uDataperawatArr))
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		const vJmlTahunlaporan	= parseInt(uSystemsettingObj.jml_tahun_laporan)||5;
		const vCabangID 		= uFormdataObj.cabang_id || 0;
		const vCabangviewArr	= uTokenObj.userhak==="FREEROLE" ? uDatacabangArr
			: uDatacabangArr.filter(vItems=>(uTokenObj.user_cabangarr || []).includes(vItems.id.toString()))
		const vTahunnow			= (new Date()).getFullYear();
		const vPerawatviewArr	= uDataperawatArr;
			//uDataperawatArr.filter(vItems=>(vItems.cabang_arr || []).includes(vCabangID.toString()))

		return (
		<CForm>
		{uDatacabangArr.length > 1 && (
		<CRow className="my-2">
			<CCol xs="3" md="4">Cabang</CCol>
			<CCol className="text-end">
			<CFormSelect size="sm"
				value={uFormdataObj.cabang_id||0}
				onChange={(e)=>{uFormdataObj.cabang_id = e.target.value; setEfekview(!uEfekview)}}
				id="inpcabangid">
				{vCabangviewArr.map((vItems,vKeys)=>{
					const {
						id,cabang_nama
					} = vItems

					return (
					<option value={id} key={vKeys}>{(cabang_nama||"UNDF").toUpperCase()}</option>
					)
				})}
			</CFormSelect>
			</CCol>
		</CRow>
		)}

		<CRow className="my-2">
		<CCol xs="3" md="4">Periode</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormInput size="sm" type="date"
				value={uFormdataObj.tgl_awal}
				onChange={(e)=>{uFormdataObj.tgl_awal=e.target.value;setEfekview(!uEfekview)}}
				id="inptglawal"/>
			<CInputGroupText>s.d.</CInputGroupText>
			<CFormInput size="sm" type="date"
				value={uFormdataObj.tgl_akhir}
				onChange={(e)=>{uFormdataObj.tgl_akhir=e.target.value;setEfekview(!uEfekview)}}
				id="inptglakhir"/>
			</CInputGroup>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="3" md="4">{uBahasaObj.word_perawat||"Perawat"}</CCol>
		<CCol className="text-end">
			<CFormSelect size="sm"
				value={uFormdataObj.perawat_id || "0"}
				onChange={(e)=>{uFormdataObj.perawat_id = e.target.value; setEfekview(!uEfekview)}}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inpperawatid">
				<option value="0">&middot;&middot; SEMUA PERAWAT &middot;&middot;</option>
				{vPerawatviewArr.map((vItems,vKeys)=>{
				return (
					<option value={vItems.id} key={vKeys}>
					{(vItems.nama_perawat||"UNDF").toUpperCase()}
					</option>
				)
				})}
			</CFormSelect>
		</CCol>
		</CRow>
		</CForm>
		)//->
	}
	const contentLaporan = () => {
		if(!uIsDataloaded) return ""

		if(uJmlData <= 0) return (
			<div className="mx-md-5 px-lg-5">
			&middot;&middot; {uBahasaObj.caption_dataempty||"Data Tidak Ada"} &middot;&middot;
			</div>
		)//->

		//console.log("(Lapperawat - contentLaporan) uFilterObj.jenis => "+uFilterObj.jenis);
		if(parseInt(uFilterObj.perawat_id||"0") <= 0) 
			return contentBulanall()

		if(parseInt(uFilterObj.perawat_id||"0") > 0)
			return contentBulanperawat()

		return ""
	}
	const contentBulanperawat = () => {
		if(parseInt(uFilterObj.perawat_id||"0") <= 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vDataviewArr	= uDatamainArr.slice(vMin,(vMax));

		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}
		const vWidthtabel = 900;

		return (
		<div style={{overflowX:"auto"}} className="" id="iddivtabel">
		<table 
			style={{minWidth:vWidthtabel,width:"100%"}}
			className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="align-top text-center classfontsmaller">
			<th width={40} className="px-1" style={vStylekolfixed}>No</th>
			<th width={130} className="text-start px-1" style={{...vStylekolfixed,left:40}}>{uBahasaObj.caption_tglperiksa||"Tgl Periksa"}</th>
			<th width={120} className="text-start">{uBahasaObj.caption_tgllunas||"Tgl Lunas"}</th>
			<th className="px-1 text-start" width="20%">
				{uBahasaObj.word_pasien||"Pasien"} / {uBahasaObj.word_dokter||"Dokter"}
			</th>
			<th className="px-1 text-start">
				{uBahasaObj.word_catatan||"Catatan"}
			</th>
			<th width={40} className="px-1 d-none d-md-table-cell">&middot;</th>
			<th width={100} className="px-1">
				<span className={"me-1"+((uSortedObj.nama||"")==="nilai_poin" ? " text-danger" : "")}>
				{uBahasaObj.caption_jmlpoin||"Jml Poin"}
				</span>
				<CLink className={"classcursorpointer text-black"}
					onClick={()=>hdlKlikSort("nilai_poin")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_poin" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
			</th>
			<th width={120} className="px-1">
				<span className={"me-1"+((uSortedObj.nama||"")==="rate_bintang" ? " text-danger" : "")}>
				{uBahasaObj.caption_ratebintang||"Rate Bintang"}
				</span>
				<CLink className={"classcursorpointer text-black"}
					onClick={()=>hdlKlikSort("rate_bintang")}>
				<CIcon icon={((uSortedObj.nama||"")==="rate_bintang" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
			</th>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys)=>{
			const {
				id,dokter_caption,pasien_caption,catatan,rate_bintang,
				nilai_poin,tgl_periksa,tgl_lunas,is_loading
			} = vItems;

			vNumber++;
			return (
			<tr id={"idtr"+id} className={"align-top text-end"+(uRowselect===vKeys?" classrowselect":"")}
				 key={vKeys}>
			<td className="px-1" style={vStylekolfixed}>{vNumber}.</td>
			<td className="px-1 text-start d-flex d-md-table-cell" style={{...vStylekolfixed,left:40}}>
				<small>{UFunc.TglAngka(tgl_periksa)}</small>
				{(is_loading||false)=== true ? (
					<CSpinner color="primary" className="d-md-none" size="sm"/>
				) : (
					<CLink onClick={()=>hdlKlikDetil(id)} className="d-md-none">
					<CIcon icon="cilSearch" className="classikonbox" height={25}/>
					</CLink>
				)}
			</td>
			<td className="px-1 text-start"><b>
				{(tgl_lunas||"")!=="" ? UFunc.TglAngka(tgl_lunas) : "-"}
			</b></td>
			
			<td className="text-start px-1">
				<div className="text-capitalize text-info">{pasien_caption||"UNDF"}</div>
				<small className="fw-bolder d-block">{(dokter_caption||"UNDF")}</small>
			</td>
			
			<td className="text-start px-1">
				<i>{catatan || "-"}</i>
			</td>
			
			<td className="text-center px-1 d-none d-md-table-cell">
				{(is_loading||false)=== true ? (
					<CSpinner color="primary" size="sm"/>
				) : (
					<CTooltip content="--Detil Kunjungan">
					<CLink onClick={()=>hdlKlikDetil(id)} className="classcursorpointer">
					<CIcon icon="cilSearch" className="classikonbox" height={25}/>
					</CLink>
					</CTooltip>
				)}
			</td>

			<td className="px-1 text-center">
				<big className="text-success fw-bolder">{UFunc.formatAngka(nilai_poin)}</big>
			</td>

			<td className="px-1 text-center">
				<big className="text-warning fw-bolder align-top">{UFunc.formatAngka(rate_bintang)}</big>
				<CIcon icon="cilStar" className="ms-1 text-warning fw-bolder" height={11}/>
			</td>
			</tr>
			)
		})}
		</tbody>

		<tfoot>
		<tr className="fw-bolder bg-primary text-white">
			<td className="px-1 text-center bg-primary" colSpan={2} style={vStylekolfixed}>JML/Rata2</td>
			<td className="px-1" colSpan={4}/>
			<td className="text-center px-1">{UFunc.formatAngka(uDatasumArr.nilai_poin)}</td>
			<td className="text-center px-1">{UFunc.formatAngka(uDatasumArr.rate_bintang)}</td>
		</tr>
		</tfoot>
		</table>
		</div>
		)//->
	}
	const contentBulanall = () => {
		if(parseInt(uFilterObj.perawat_id||"0") > 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vDataviewArr	= uDatamainArr.slice(vMin,(vMax));
		const vKolkasir		= (uFilterObj.perawat_id||"0")==="0" ? 0 : 1;
		
		return (
		<div className="mx-lg-5 px-lg-5">
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="text-center align-top classfontsmaller">
			<th width={40} className="px-1 border">No</th>
			<th className="px-1 border text-start">
				{uBahasaObj.caption_namaperawat||"Nama Perawat"}
			</th>
			<th width="15%" className="px-1 border">
				<span className={"me-1"+((uSortedObj.nama||"")==="nilai_poin" ? " text-danger" : "")}>
				{uBahasaObj.caption_jmlpoin||"Jml Poin"}
				</span>
				<CLink className={"classcursorpointer text-black"}
					onClick={()=>hdlKlikSort("nilai_poin")}>
				<CIcon icon={((uSortedObj.nama||"")==="nilai_poin" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
			</th>
			<th width="15%" className="px-1 border">
				<span className={"me-1"+((uSortedObj.nama||"")==="rate_bintang" ? " text-danger" : "")}>
				{uBahasaObj.caption_raterata||"Rata2 Rating"}
				</span>
				<CLink className={"classcursorpointer text-black"}
					onClick={()=>hdlKlikSort("rate_bintang")}>
				<CIcon icon={((uSortedObj.nama||"")==="rate_bintang" && (uSortedObj.jenis||"")==="DESCENDING" ? "cilArrowBottom" : "cilArrowTop")}
					className="align-middle" height={20}/>
				</CLink>
			</th>
			</tr>
		</thead>
		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				nama_perawat,nilai_poin,rate_bintang
			} = vItems;

			vNumber++;
			return (
			<tr className={"align-top text-end "+(uRowselect===vKeys?"classrowselect":"")}
				 key={vKeys}>
			<td className="px-1">{vNumber}.</td>
			<td className="px-1 text-start">
				<b>{nama_perawat||"UNDF"}</b>
			</td>
			<td className="px-1 text-center">
				<big className="text-success fw-bolder">{UFunc.formatAngka(nilai_poin)}</big>
			</td>
			<td className="px-1 text-center">
				<big className="text-warning fw-bolder align-middle">{UFunc.formatAngka(rate_bintang)}</big>
				<CIcon icon="cilStar" className="ms-1 text-warning fw-bolder" height={11}/>
			</td>
			</tr>
			)
		})}
		</tbody>

		<tfoot>
			<tr className="fw-bolder bg-primary text-white">
			<td className="px-1 text-center" colSpan={2}>JUMLAH</td>
			<td className="px-1 text-center">{UFunc.formatAngka(uDatasumArr.nilai_poin)}</td>
			<td className="px-1 text-center">{UFunc.formatAngka(uDatasumArr.rate_bintang)}</td>
		</tr>
		</tfoot>
		</table>
		</div>
		)//->
	}
	const contentCetak = () => {
		if(uDatamainArr.length <= 0) return "";
		//console.log("(Lapperawat - contentCetak) vHTMLs => "+vHTMLs)

		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";

		const vNurseIdx		= UFunc.getObjectIndeks(uDataperawatArr,uFilterObj.perawat_id);
		const vNursecaption	= vNurseIdx >= 0 ? uDataperawatArr[vNurseIdx].nama_perawat : "";

		let vColspan		= 4;
		if(parseInt(uFilterObj.perawat_id||"0") > 0) {
			vColspan = 7;
		}

		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="`+vColspan+`">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 1 
				? `<div>Cabang: `+vCabangtext+`</div>`
				: ``)+
			(parseInt(uFilterObj.perawat_id)>0 ? "<div>Perawat: <b>"+vNursecaption+"</b></div>" : "")+`
			</td>
			</tr>
			<tr class="idtabelheader">
			`;
		if(parseInt(uFilterObj.perawat_id||"0") > 0)
			vHTMLs += `
				<th width="5%">No</th>
				<th width="10%" align="left">`+(uBahasaObj.caption_tglperiksa||"Tgl Periksa")+`</th>
				<th width="10%" align="left">`+(uBahasaObj.caption_tgllunas||"Tgl Lunas")+`</th>
				<th width="25%" align="left">`+
					(uBahasaObj.word_pasien||"Pasien")+` / `+
					(uBahasaObj.word_dokter||"Dokter")+`</th>
				<th align="left">`+(uBahasaObj.word_catatan||"Catatan")+`</th>
				<th width="9%">`+(uBahasaObj.caption_jmlpoin||"Jml Poin")+`</th>
				<th width="9%">`+(uBahasaObj.caption_ratebintang||"Rating")+`</th>
			`;
		else
			vHTMLs += `
				<th width="5%">No</th>
				<th align="left">`+(uBahasaObj.caption_namaperawat||"Nama Perawat")+`</th>
				<th width="10%">`+(uBahasaObj.caption_jmlpoin||"Jml Poin")+`</th>
				<th width="10%">`+(uBahasaObj.caption_raterata||"Rate Rata2")+`</th>
			`;
		vHTMLs += `
			</tr>
			</thead>
			<tbody>`;
		uDatamainArr.forEach((vItems,vKeys)=>{
			const {
				id,pasien_caption,dokter_caption,catatan,
				nama_perawat,nilai_poin,rate_bintang,
				tgl_periksa,tgl_lunas,
			} = vItems;

			if(parseInt(uFilterObj.perawat_id||"0") > 0)
				vHTMLs 	+= `
				<tr key={vKeys} valign="top">
					<td align="right" style="font-size:smaller">`+(vKeys+1)+`.</td>
					<td align="left" style="font-size:smaller">`+UFunc.TglAngka(tgl_periksa)+`</td>
					<td align="left" style="font-size:smaller">`+
						((tgl_lunas||"")!=="" ? UFunc.TglAngka(tgl_lunas) : "-")+
					`</td>
					<td align="left">
						<div>`+(pasien_caption||"")+`</div>
						<small>`+(dokter_caption||"")+`</small>
					</td>
					<td align="left">`+(catatan||"-")+`</td>
					<td align="center">`+UFunc.formatAngka(nilai_poin)+`</td>
					<td align="center">`+UFunc.formatAngka(rate_bintang)+`</td>
				</tr>
				`;
			else
				vHTMLs 	+= `
				<tr key={vKeys} valign="top">
					<td align="right" style="">`+(vKeys+1)+`.</td>
					<td align="left" style="font-weight:bolder">`+(nama_perawat||"UNDF")+`</td>
					<td align="center">`+UFunc.formatAngka(nilai_poin)+`</td>
					<td align="center">`+UFunc.formatAngka(rate_bintang)+`</td>
				</tr>
				`;
		});
		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
			<td colspan="`+(vColspan-2)+`" align="center">JML/Rata2</td>
			<td align="center">`+UFunc.formatAngka(uDatasumArr.nilai_poin)+`</td>
			<td align="center">`+UFunc.formatAngka(uDatasumArr.rate_bintang)+`</td>
			</tr>
			</tfoot>
			</table>
		`;
		return vHTMLs		
	}
	const contentDlgview = () => {
		if(!uISDlgviewshow) return (<></>)//>

		const vDatadetilObj	= uDlgviewObj.data_obj || {};

		return (
		<>
		<CRow className="align-items-stretch">
		<CCol lg="6" className="mb-3">
			<CCard className="h-100">
			<CCardHeader className="classfontsmaller py-0 pt-1">
				<small>Data Pasien</small>
			</CCardHeader>

			<CCardBody>
			<small>
				<div className="d-flex justify-content-between my-1">
					<div>Tgl Periksa</div>
					<div className="fw-bolder text-end">{UFunc.TglAngka(vDatadetilObj.tgl_periksa)}</div>
				</div>

				<div className="d-flex justify-content-between my-1">
					<div>Tgl Lunas</div>
					<div className="fw-bolder text-end">
					{(vDatadetilObj.tgl_lunas||"") ? UFunc.TglAngka(vDatadetilObj.tgl_lunas) : "-"}
					</div>
				</div>

				<div className="d-flex justify-content-between my-1">
					<div>Nama Pasien</div>
					<div className="fw-bolder text-end">{vDatadetilObj.pasien_caption||"Undf"}</div>
				</div>

				<div className="d-flex justify-content-between my-1">
					<div>Anamnase</div>
					<div className="fw-bolder text-end">{vDatadetilObj.anamnase||"Undf"}</div>
				</div>
			</small>
			</CCardBody>
			</CCard>
		</CCol>

		<CCol className="mb-3">
			<CCard className="h-100">
			<CCardHeader className="classfontsmaller py-0 pt-1">
				<small>Penilaian</small>
			</CCardHeader>

			<CCardBody>
			<small>
				<div className="d-flex justify-content-between my-1">
					<div>Rating Layanan</div>
					<div className="fw-bolder text-end">
						<span className="align-middle">{vDatadetilObj.rate_bintang||"0"}</span>
						<CIcon icon="cilStar" className="text-warning ms-1" height={11}/>
					</div>
				</div>
				
				<div className="classborderbottom my-2"/>

				<div className="d-flex justify-content-between my-1">
					<div className="pe-1">Catatan</div>
					<div className="ps-1 text-end fst-italic">{vDatadetilObj.catatan||"-"}</div>
				</div>
			</small>
			</CCardBody>
			</CCard>
		</CCol>
		</CRow>

		<CCard>
			<CCardHeader className="classfontsmaller py-0 pt-1">
				<small>Data Terapi</small>
			</CCardHeader>

			<CCardBody className="px-0">
			<small>
			<table className="table table-borderless table-striped" id="idtabeldetil">
			<thead>
				<tr className="classfontsmaller fw-bolder text-center">
				<th width={40}>No</th>
				<th className="text-start">Nama Terapi</th>
				<th width="15%" style={{minWidth:70}}>Total</th>
				</tr>
			</thead>

			<tbody>
			{(vDatadetilObj.data_arr||[]).map((vItems,vKeys)=>{
				const {
					caption_terapi,keterangan,qty,poin_perawat,
					id,
				} = vItems;

				return (
				<tr className="align-top" key={vKeys}>
				<td className="text-end">{vKeys+1}.</td>
				
				<td className="text-start">
					<div>
					<i>{caption_terapi}</i>
					{(keterangan||"")!=="" && (
					<>
						<span className="mx-1">&middot;</span>
						<b>{keterangan}</b>
					</>
					)}
					</div>

					<div>
						(
						<b>{UFunc.formatAngka(qty)}</b> UNT
						<span className="mx-1">x</span>
						<b className="text-primary">{UFunc.formatAngka(poin_perawat)}</b> POIN
						)
					</div>
				</td>

				<td className="text-center fw-bolder text-primary">
					{UFunc.formatAngka(
						(parseInt(qty)||1) * (parseFloat(poin_perawat))
					)}
				</td>
				</tr>
				)//->
			})}
			</tbody>

			<tfoot className="border-top">
				<tr className="align-top fw-bolder">
				<td colSpan={2} className="text-end">Jml POIN</td>
				<td className="text-center">
					{UFunc.formatAngka(vDatadetilObj.jml_poin_perawat)}
				</td>
				</tr>

				<tr className="align-top">
				<td colSpan={2} className="text-end">Jml PERAWAT</td>
				<td className="text-center">
					{UFunc.formatAngka(vDatadetilObj.jml_perawat)}
				</td>
				</tr>

				<tr className="align-top">
				<td colSpan={2} className="text-end">
					<b className="text-success">POIN PERAWAT</b>

					<small className="mx-1">&middot;</small>
					
					<i className="classfontsmaller text-muted text-uppercase">
					<small>(Jml Poin / Jml Perawat)</small>
					</i>
				</td>
				<td className="text-center border-top fw-bolder text-success">
					{UFunc.formatAngka(
						(parseFloat(vDatadetilObj.jml_poin_perawat)||0) /
						(parseInt(vDatadetilObj.jml_perawat)||1)
					)}
				</td>
				</tr>
			</tfoot>
			</table>
			</small>
			</CCardBody>
		</CCard>
		</>
		)//->
	}
	//--END CONTENT--/

	//--REST_API--/
	const apiLoadawal = () => {
		setHtml500msg();
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Lapperawat - apiLoadawal) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
			setDataperawatArr(vTmpArr);
		},2500); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lapperawat/ld_init";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				setDataperawatArr(JSON.parse(output_string.dataperawat||"[]"));
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapperawat - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg(vMsg);
			} else if(output_string.expired) {
				setDlgformshow(false); setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Lapperawat - apiLoadawal) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoaddata = () => {
		uElBtnsimpan && (uElBtnsimpan.disabled = true)
		setLoading(true);
		const vTmpFilterObj 		= uFormdataObj;
		vTmpFilterObj.init_change 	= undefined;

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
		},2500); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_filterlist : JSON.stringify(vTmpFilterObj),
			//send_pg	: _PAGE <= 0 ? 1 : _PAGE,
			//send_maxdata	: uMaxData,
			send_firstload	: uFirstload,//vHandelview,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lapperawat/ld_laporan";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			if(output_string.tampil) {
				setFilterObj(vTmpFilterObj);
				const vLoadArr	= JSON.parse(output_string.dataobject||"[]");
				/*//--LOAD_PER_PAGE--/
				vLoadArr.map(vItems=>vItems.pg = parseInt(_PAGE)||1);
				setDatamainArr([...vDatamainArr,...vLoadArr]);
				setJmlData(parseInt(output_string.totaldata||uJmlData));
				//--END LOAD_PER_PAGE--*/

				//--LOAD_ALL_VIEW_PER_PAGE--/
				setDatamainArr(vLoadArr);
				//setJmlData(vLoadArr.length);
				//--END LOAD_ALL_VIEW_PER_PAGE--*/

				setFirstload("TIDAK");
				
				hdlToggleDlgform();
				setDataloaded(true);
				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapperawat - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			console.log("(Lapperawat - apiLoaddata) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiLoaddetil = () => {
		const vTabelid	= parseInt(uDlgviewObj.tabelid)||0; if(vTabelid<=0) return;
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,vTabelid);
		uDatamainArr[vArridx].is_loading = true;
		setEfekview(!uEfekview);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
		},2500); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : vTabelid,
			send_cabangid : uFilterObj.cabang_id,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lapperawat/ld_detil";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			uDatamainArr[vArridx].is_loading = false;
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				const vTmpArr	= JSON.parse(output_string.datadetil || "[]");
				uDatamainArr[vArridx].data_arr = vTmpArr;

				uDlgviewObj.data_obj	= uDatamainArr[vArridx] || {};
				setDlgviewshow(true);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapperawat - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uDatamainArr[vArridx].is_loading = false;
			console.log("(Lapperawat - apiLoaddata) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END REST_API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});
		
		apiLoadawal();

		return () => {
			setDataloaded(false)
			setDlgformshow(false);setDlgviewshow(false);
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDatamainArr([]);setDataperawatArr([]);
		}
	},[])
	React.useEffect(()=>{ initJmldata() },[uElJmlData])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		initJmldata()
	},[uJmlData])
	React.useEffect(()=>{ 
		if(uDatamainArr.length <= 0)
			{ setDatadefaultArr([]); return }
		setDatadefaultArr([{init_change:"1"},...uDatamainArr]) 
	},[uDatamainArr])
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length)
		if(uDatamainArr.length <= 0)
			{ setDatasumObj({}); return }

		const vSumtotal	= uDatamainArr.reduce(
			(vStores,vItems) => vStores = vStores + parseFloat(vItems.nilai_poin||"0"), 0);
		const vRataRate	= uDatamainArr.reduce(
			(vStores,vItems) => vStores = vStores + parseFloat(vItems.rate_bintang||"0")
			, 0) / uDatamainArr.length; 
		setDatasumObj({
			nilai_poin: vSumtotal,
			rate_bintang: vRataRate,
		});
	},[uDatamainArr,uDatamainArr.length])
	React.useEffect(()=>{
		/*//--LOAD_PER_PAGE--/
		if(uFirstload==="YA") return;

		setIDselect(0);
		setRowselect(-1);
		const vDatapageArr = uDatamainArr.filter(vItems=>parseInt(vItems.pg||0)===parseInt(uPageActive||1));
		if(vDatapageArr.length > 0) { 
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}

		apiLoaddata(uPageActive);
		//--END LOAD_PER_PAGE--*/

		//--LOAD_ALL_VIEW_PER_PAGE--/
		setIDselect(0);
		setRowselect(-1);
		//--END LOAD_ALL_VIEW_PER_PAGE--/
	},[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		if(!uHandelView) return;
		if(uHtml500msg) {
			uHeaderActionObj.isHeaderView = false;
			uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
			setEfekview(!uEfekview);
			return;
		}

		setHeaderDlgform("Pilih Filter Laporan")
		setDlgformshow(true)
		setFormdataObj({...uFilterObj, init_change: 1});

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelReset) return;

		if(uHtml500msg) { apiLoadawal(); }
		else { setDataloaded(false); }

		uHeaderActionObj.isHeaderreset = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
	},[uHandelReset])
	React.useEffect(()=>{
		if(!uIsDataloaded)
			{ initResettampilan(); return; }

		//--SET_TITLE--/
		let vTitelmain	= "Periode ";
		vTitelmain += "<b>"+UFunc.HariAngka(uFormdataObj.tgl_awal)+" s.d. "+UFunc.HariAngka(uFormdataObj.tgl_akhir)+"</b>";

		const vCabangIdx= UFunc.getObjectIndeks(uDatacabangArr,uFormdataObj.cabang_id);
		let vTitelsub	= uDatacabangArr.length > 1 ? (uDatacabangArr[vCabangIdx]||{}).cabang_nama : "";

		if(vTitelsub !== "") vTitelsub += " &middot ";
		if(parseInt(uFormdataObj.perawat_id) > 0) {
			const vNurseIdx= UFunc.getObjectIndeks(uDataperawatArr,uFormdataObj.perawat_id);
			vTitelsub	+= ""+(uDataperawatArr[vNurseIdx]||{}).nama_perawat;
		} else {
			vTitelsub	+= "[SEMUA PERAWAT]";
		}

		//vTitelsub = "&middot; "+vTitelsub+" &middot;";
		setCaptionObj({title:vTitelmain,title_sub:vTitelsub});
		//--END SET_TITLE--/
	},[uIsDataloaded])
	React.useEffect(()=>{
		//console.log("(Lapperawat - [uISDlgformshow]) uFilterObj => "+JSON.stringify(uFilterObj));
		if(!uISDlgformshow) 
			{ setFormdataObj({}); return }

		if(uFormdataObj.cabang_id === undefined)
			uFormdataObj.cabang_id = localStorage.getItem("lastcabangid") 
				|| (uDatacabangArr[0].id || "0");
		if(uFormdataObj.perawat_id === undefined)
			uFormdataObj.perawat_id = "0";

		const vTanggalnowDT			= new Date();
		const vTanggalLastmonthDT 	= new Date();//UFunc.toDate("2023-02-03");
		if(uFormdataObj.tgl_awal === undefined) {
			vTanggalLastmonthDT.setMonth(vTanggalLastmonthDT.getMonth() - 1);
			uFormdataObj.tgl_awal = vTanggalLastmonthDT.getFullYear()+"-"+
			UFunc.leadZero(vTanggalLastmonthDT.getMonth()+1)+"-26"+
			"";
		}
		if(uFormdataObj.tgl_akhir === undefined)
			uFormdataObj.tgl_akhir = vTanggalnowDT.getFullYear()+"-"+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+"-25"+
			"";

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vButton = document.getElementById("btnDialogSimpan");
			vButton && (vButton.innerHTML = "Tampilkan");
			setElBtnsimpan(vButton);
			
			let vElfocus = document.getElementById("inpcabangid");
			if(!vElfocus)
				vElfocus = document.getElementById("inptglawal");
	
			if(!isMobile)
				vElfocus && vElfocus.focus();
		},350)
	},[uISDlgformshow])
	React.useEffect(()=>{
		if(!uISDlgviewshow) 
			{ setDlgviewObj({}); return }
	},[uISDlgviewshow])
	React.useEffect(()=>{
		if(uDatamainArr.length <= 0) return;
		if(uPageActive > 1) setPageActive(1);
		else 
			{ setRowselect(-1); setIDselect(0); }

		if(JSON.stringify(uSortedObj||{}) === "{}") { return; }

		let vSortedArr;
		const vNamasort = (uSortedObj.nama||"").toLowerCase();
		const vISNumeric= UFunc.isNumeric(uDatamainArr[0][vNamasort]);
		if(uSortedObj.jenis === "ASCENDING") {
			vSortedArr	= !vISNumeric
				? uDatamainArr.sort((a, b) => {
					return (a[vNamasort] > b[vNamasort]) ? 1 : ((b[vNamasort] > a[vNamasort]) ? -1 : 0) 
					}) 
				: uDatamainArr.sort((a, b) => a[vNamasort] - b[vNamasort]) ;
		}else if(uSortedObj.jenis === "DESCENDING") {
			vSortedArr	= !vISNumeric
				? uDatamainArr.sort((a, b) => {
					return (b[vNamasort] > a[vNamasort]) ? 1 : ((a[vNamasort] > b[vNamasort]) ? -1 : 0) 
				})
				: uDatamainArr.sort((a, b) => b[vNamasort] - a[vNamasort]);
		} else {
			vSortedArr	= uDatadefaultArr.slice(1);//.splice(0,1);
		}
		setDatamainArr(vSortedArr);
		setEfekview(!uEfekview);
	},[uSortedObj,
	uSortedObj.nama,
	uSortedObj.jenis,
	])
	
	//console.log("(Lapperawat) uActiveroute => "+(uActiveroute));
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return; }
	if(uHtml500msg) return (
		<CCard className="classbgcard">
		<CCardHeader className="fw-bolder">Page 500</CCardHeader>
		<CCardBody className="mx-md-5 p-md-5">
		<div className="fst-italic">
		{UFunc.renderHTML(uHtml500msg)}
		</div>
		</CCardBody>
		</CCard>
	)

	return (
		<>
		{(!uIsDataloaded) ? (
		<CCard className="classbgcard">
			<CCardHeader className="fw-bolder">Pilih Filter Laporan</CCardHeader>
			<CCardBody className="mx-md-5 p-md-5">
			<div className="mx-lg-5 px-lg-5 fst-italic classpetunjuk">
			*) Silahkan Pilih Filter, untuk menentukan Parameter Laporan yang akan Ditampilkan. Kemudian Tekan SIMPAN. Untuk Mencetak Silahkan KLIK Ikon Cetak..
			</div>
			</CCardBody>
		</CCard>
		) : (
		<CCard className="classbgcard">
			<CCardHeader className="d-flex justify-content-between px-1 px-md-3">
			<div>
				<div className="d-none d-md-block">{UFunc.renderHTML(uCaptionObj.title)}</div>
				<div className="d-md-none classfontsmaller"><small>{UFunc.renderHTML(uCaptionObj.title)}</small></div>
				<span className="classfontsmaller text-primary">
					<small>{UFunc.renderHTML(uCaptionObj.title_sub)}</small>
				</span>
			</div>

			<div>
				<span className="d-none d-md-inline">
				<CTooltip content="--CETAK..">
				<CLink 
					className="classikon classikoncetak classcursorpointer"
					onClick={()=>hdlKlikCetak()}/>
				</CTooltip>

				<CTooltip content="--Export-2-Excel..">
				<CLink 
					className="classikon classikonexcel classcursorpointer"
					onClick={()=>hdlKlikExcel()}/>
				</CTooltip>

				<span className="mx-1">&middot;</span>
				</span>

				<span className="text-muted classfontsmaller">
				<small>{UFunc.formatAngka(uTimeelapse)} ms</small>
				</span>
				<span className="mx-1 d-md-none">&middot;</span>

				<CDropdown className="d-md-none">
				<CDropdownToggle caret={false} size="sm"
					className="p-0" color="transparent">
					<CIcon icon="cilChevronBottom" className="classikonbox mx-1" height={25}/>
				</CDropdownToggle>
				<CDropdownMenu>
					<CDropdownItem onClick={()=>hdlKlikCetak()}>
						<CIcon className="classikoncetak ms-0 me-2 align-middle" height={25}/>
						Cetak Laporan
					</CDropdownItem>
					<CDropdownItem onClick={()=>hdlKlikExcel()}>
						<CIcon className="classikonexcel ms-0 me-2 align-middle" height={25}/>
						Export-2-Excel
					</CDropdownItem>
				</CDropdownMenu>
				</CDropdown>
			</div>
			</CCardHeader>
		
			<CCardBody className="px-0">{contentLaporan()}</CCardBody>

			{(uJmlData > uMaxData) && (
			<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/>
			</CCardFooter>
			)}
		</CCard>
		)}

		<MyDialogview
			options={{centered:true}}
			show={uISDlgviewshow} 
			dialogHeader={uDlgviewObj.dlg_header}
			toggle={()=>setDlgviewshow(false)}
			renderContent={contentDlgview()}/>

		<MyDialogform
			options={{centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uHeaderDlgform}
			toggle={hdlToggleDlgform}
			renderContent={contentDlgform()}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		<div className="d-none">
			{(uSystemsettingObj.url_image_nota||"")!=="" && (
				<img src={uSystemsettingObj.url_image_nota} height="100"/>
			)}
		</div>
		</>
	)
}	

export default Lapperawat